/* assets/pbm-quick-order.js  OPP-05 P5 Quick Order v2 (2026-10-24), for sections/pbm-quick-order.liquid.
   Plain JS, no dependencies, no globals. Reading and matching live in assets/pbm-quick-order-engine.js
   (window.PBMQuickOrderEngine), a line-for-line port of the tested reference engine; this file is the page:
   - the part number index (templates/collection.quick-order-index3.liquid, v3 rows), loaded once, kept 30 minutes;
   - search for the engine: Searchanise (the header search bar's engine, its public key from the app embed on the
     page), storefront search (templates/search.quick-order3.liquid) only when Searchanise cannot be reached;
   - Amazon's building blocks: a search box with a product dropdown, "Paste a list", "Your list" as cart rows
     (Ready / Needs a look / Not found), a receipt line, skipped lines with "Add as item", a summary with one Add to
     Cart (top on phones, right on a computer), Undo, Clear list;
   - Add to Cart: one POST to /cart/add.js (properties._src = quick_order), then /cart; on a 422 one line at a time.
   Nothing fuzzy is picked for the buyer: only the engine's "locked" lines are Ready on their own. No stock words.
   Clarity events carry counts only, never what the buyer typed. */
(function () {
  'use strict';
  var d = document;
  var w = window;
  var root = d.getElementById('pbm-qo2');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  var E = w.PBMQuickOrderEngine;
  if (!E) return;

  var T = {};
  try { T = JSON.parse(d.getElementById('pbm-qo2-text').textContent) || {}; } catch (e) {}
  function attr(n, f) { var v = root.getAttribute('data-' + n); return v == null || v === '' ? f : v; }
  var IDX_URL = attr('index-url', '');
  var SEARCH_URL = attr('search-url', '/search?type=product&view=quick-order3');
  var ADD_URL = attr('cart-add', '/cart/add.js');
  var CART_URL = attr('cart', '/cart');
  var MONEY = attr('money', '${{amount}}');
  var GATE = attr('gate', '0') === '1';
  var MAX = parseInt(attr('max', '100'), 10) || 100;
  var IDX_KEY = 'pbm_qo2_idx_v3p:' + IDX_URL;       // v3 rows with the photo field
  var LIST_KEY = 'pbm_qo2_list_v1';
  var TTL = 30 * 60 * 1000;
  var SN_TIMEOUT = 4000;
  var DD_DELAY = 220;

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  var sInput = $('.qo2-sinput'), ddBox = $('#qo2-dd'), pasteBox = $('[data-qo2-paste]');
  var listEl = $('[data-qo2-list]'), listWrap = $('[data-qo2-listwrap]');
  var receiptEl = $('[data-qo2-receipt]'), bannerEl = $('[data-qo2-banner]'), msgEl = $('[data-qo2-msg]');
  var skippedEl = $('[data-qo2-skipped]'), bottomEl = $('[data-qo2-bottom]'), toastEl = $('[data-qo2-toast]'), liveEl = $('[data-qo2-live]');
  var pasteWrap = $('[data-qo2-pastebox]'), moreEl = $('[data-qo2-more]'), findBtn = $('[data-qo2-find]');

  /* the theme's header is fixed while scrolling: keep the summary box and rows we scroll to below it */
  var gapQueued = false;
  function headerGap() {
    var h = d.getElementById('header') || d.querySelector('header'), b = 0, cs;
    if (h) { cs = w.getComputedStyle(h); if (cs.position === 'fixed' || cs.position === 'sticky') b = Math.max(0, h.getBoundingClientRect().bottom); }
    root.style.setProperty('--qo2-top', Math.round(b + 16) + 'px');
  }
  function queueGap() { if (!gapQueued) { gapQueued = true; (w.requestAnimationFrame || setTimeout)(function () { gapQueued = false; headerGap(); }); } }
  w.addEventListener('scroll', queueGap, { passive: true });
  w.addEventListener('resize', queueGap);
  headerGap();

  /* ---------------------------------------------------------------- helpers */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var n = (Number(cents) || 0) / 100, parts = n.toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return whole;
      if (k === 'amount_with_comma_separator') return whole.replace(/,/g, '.') + ',' + parts[1];
      return whole + '.' + parts[1];
    });
  }
  function clarity(a, b, c) { try { if (typeof w.clarity === 'function') w.clarity(a, b, c); } catch (e) {} }
  function store(k, v) { try { if (v == null) w.sessionStorage.removeItem(k); else w.sessionStorage.setItem(k, v); } catch (e) {} }
  function load(k) { try { return w.sessionStorage.getItem(k); } catch (e) { return null; } }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) { return JSON.parse(t); });
  }
  function withTimeout(p, ms) {
    return new Promise(function (ok, no) {
      var t = setTimeout(function () { no(new Error('timeout')); }, ms);
      p.then(function (v) { clearTimeout(t); ok(v); }, function (e) { clearTimeout(t); no(e); });
    });
  }
  function wait(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }
  function say(text) { liveEl.textContent = ''; setTimeout(function () { liveEl.textContent = text; }, 30); }
  var toastTimer = null;
  function toast(html, undo) {
    clearTimeout(toastTimer);
    toastEl.innerHTML = html + (undo ? ' <button type="button" class="qo2-link" data-qo2-undo>Undo</button>' : '');
    toastEl.hidden = false;
    toastEl.__undo = undo || null;
    toastTimer = setTimeout(function () { toastEl.hidden = true; toastEl.__undo = null; }, undo ? 6000 : 3500);
  }
  toastEl.addEventListener('click', function (e) {
    if (e.target.closest('[data-qo2-undo]') && toastEl.__undo) { var u = toastEl.__undo; toastEl.__undo = null; toastEl.hidden = true; u(); }
  });

  /* ---------------------------------------------------------------- index */
  var ixPromise = null, IX = null;
  function ensureIndex() {
    if (ixPromise) return ixPromise;
    try {
      var c = JSON.parse(load(IDX_KEY) || 'null');
      if (c && c.rows && c.rows.length && Date.now() - c.t < TTL) { photos(c.rows); return (ixPromise = Promise.resolve(IX = E.buildIndex(c.rows))); }
    } catch (e) {}
    ixPromise = getJSON(IDX_URL + '&page=1').then(function (first) {
      if (!first || first.off || !first.rows) return null;
      var jobs = [], pages = Math.min(first.pages || 1, 40);
      for (var p = 2; p <= pages; p++) jobs.push(getJSON(IDX_URL + '&page=' + p));
      return Promise.all(jobs).then(function (rest) {
        var rows = first.rows;
        rest.forEach(function (x) { if (x && x.rows) rows = rows.concat(x.rows); });
        rows = rows.filter(function (r) { return r && r.length >= 11; });          // a stale cached page of an older format is skipped
        store(IDX_KEY, JSON.stringify({ t: Date.now(), rows: rows }));
        photos(rows);
        return (IX = E.buildIndex(rows));
      });
    }).catch(function () { return null; });
    return ixPromise;
  }

  /* ---------------------------------------------------------------- search for the engine */
  // Searchanise's documented /getresults API with the public front-end key every visitor already gets from the app
  // embed (window.Searchanise.ApiKey, else the init.js tag); the section's "Searchanise key" overrides. Only a
  // searchserverapiN.com host is called. Photos from the results are kept for the rows.
  var imgOf = {};
  function snizeCfg() {
    var key = attr('snize-key', ''), host = '', S = w.Searchanise;
    if (!key && S && S.ApiKey) { key = String(S.ApiKey); host = String(S.host || ''); }
    if (!key) {
      var tag = d.querySelector('script[src*="searchanise"][src*="init.js"]');
      var m = tag && /[?&]a=([A-Za-z0-9]+)/.exec(tag.src);
      if (m) key = m[1];
    }
    if (!/^searchserverapi\d*\.com$/.test(host)) host = 'searchserverapi1.com';
    return /^[A-Za-z0-9]{6,40}$/.test(key) ? { key: key, host: host } : null;
  }
  var lanes = 0, waiting = [];
  function slot() {                                      // at most 3 searches at a time
    return new Promise(function (ok) { if (lanes < 3) { lanes++; ok(); } else waiting.push(ok); });
  }
  function free() { lanes--; var n = waiting.shift(); if (n) { lanes++; n(); } }
  var sCache = {};
  function snizeOnce(q, fix, cfg) {
    var o = { api_key: cfg.key, q: q, maxResults: 8, startIndex: 0, items: 'true', suggestions: fix ? 'true' : 'false',
      facets: 'false', categories: 'false', pages: 'false', output: 'json' };
    if (fix) { o.suggestionsMaxResults = 1; o.queryCorrection = 'true'; }
    var url = 'https://' + cfg.host + '/getresults?' + Object.keys(o).map(function (n) { return n + '=' + encodeURIComponent(o[n]); }).join('&');
    return withTimeout(fetch(url), SN_TIMEOUT).then(function (r) {
      if (r.status === 429) { var e = new Error('busy'); e.busy = true; throw e; }
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  // owner: the line being matched, marked "busy" when search could not be reached for it.
  function search(q, fix, owner) {
    q = String(q || '').trim();
    if (!q) return Promise.resolve({ items: [], fixed: null });
    var k = (fix ? 'fix|' : '') + q.toLowerCase();
    if (sCache[k]) return sCache[k];
    var p = slot().then(function () {
      var cfg = snizeCfg();
      var go = cfg ? snizeOnce(q, fix, cfg).catch(function (e) {
        if (e && e.busy) return wait(2000).then(function () { return snizeOnce(q, fix, cfg); });
        throw e;
      }) : Promise.reject(new Error('no key'));
      return go.then(function (j) {
        var items = [];
        ((j && j.items) || []).forEach(function (it) {
          if (!it.link) return;
          var h = decodeURIComponent(String(it.link).split('?')[0].split('/products/')[1] || '');
          var v = (it.shopify_variants && it.shopify_variants[0]) || {};
          if (it.image_link && !imgOf[h]) imgOf[h] = it.image_link;
          items.push({ h: h, sku: v.sku || it.product_code || '', bc: v.barcode || '' });
        });
        return { items: items, fixed: j && j.correctedQuery ? String(j.correctedQuery) : null };
      }, function () {
        if (fix) return { items: [], fixed: null };
        var pq = q.replace(/[^A-Za-z0-9.\-\/ ]+/g, ' ').replace(/^[\s\-]+/, '').trim();
        if (!pq) return { items: [], fixed: null };
        return withTimeout(getJSON(SEARCH_URL + '&q=' + encodeURIComponent(pq)), SN_TIMEOUT).then(function (r) {
          photos((r && r.rows) || []);
          return { items: ((r && r.rows) || []).map(function (a) { return { h: a[1], sku: a[2] || '', bc: a[8] || '' }; }), fixed: null };
        }, function () { if (owner) owner.busy = true; delete sCache[k]; return { items: [], fixed: null }; });
      });
    }).then(function (res) { free(); return res; }, function () { free(); delete sCache[k]; if (owner) owner.busy = true; return { items: [], fixed: null }; });
    sCache[k] = p;
    return p;
  }
  // Photos: the index rows carry each product's photo path (field 11); Searchanise results carry their own; a product
  // with neither (rare) is fetched once from /products/x.js.
  function photos(rows) {
    rows.forEach(function (r) {
      if (r.length < 12 || imgOf[r[1]] !== undefined) return;
      var p = r[11] || '';
      imgOf[r[1]] = !p ? '' : /^(https?:)?\/\//.test(p) ? p : '/cdn/shop/' + p;
    });
  }
  var imgWait = {};
  function photo(h) {
    if (!h || imgOf[h] !== undefined || imgWait[h]) return;
    imgWait[h] = true;
    getJSON('/products/' + encodeURIComponent(h) + '.js').then(function (p) {
      var src = (p && (p.featured_image || (p.images && p.images[0]))) || '';
      imgOf[h] = src || '';
      $$('img[data-qo2-img]').forEach(function (im) { if (im.getAttribute('data-qo2-img') === h && imgOf[h]) im.src = sized(imgOf[h]); });
    }, function () { imgOf[h] = ''; });
  }
  function sized(src) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
  function img(it, cls) {
    var h = it.h || '', src = imgOf[h];
    if (src === undefined) photo(h);
    return '<img class="qo2-img' + (cls ? ' ' + cls : '') + '" data-qo2-img="' + esc(h) + '" alt="" width="56" height="56" loading="lazy"' +
      (src ? ' src="' + esc(sized(src)) + '"' : '') + '>';
  }

  /* ---------------------------------------------------------------- lines */
  // line: { key, raw, entry, src: paste|search, state: checking|ready|look|none, options, pick, qty, flags, fixed, busy }
  var lines = [], skipped = [], nextKey = 1, lastReceipt = '', pasteOpen = false, busyAdd = false;
  function packText(it) {
    var p = String(it.pack || '').toUpperCase(), n = it.pack_n;
    var word = { BX: 'Box', CS: 'Case', PK: 'Pack', BG: 'Bag' }[p];
    return word && n && n > 1 ? word + ' of ' + n : '';                        // single items: nothing (no "1 each")
  }
  function meta(it) {
    var bits = [];
    if (it.mpn && E.norm(it.mpn) !== E.norm(it.sku)) bits.push('Part # ' + esc(it.mpn));
    if (it.sku) bits.push('SKU ' + esc(it.sku));
    var pk = packText(it);
    if (pk) bits.push(esc(pk));
    return bits.join(' &middot; ');
  }
  var WHY = {
    family: 'Choose a size', same_number: 'These items share this part number', desc_mismatch: 'The description points to a different item',
    unit_conflict: 'Check the pack: your list and this item differ', slash_pair: 'Two part numbers with a slash: add both, or one?',
    qty_extra: 'Check the quantity: the line has another number', qty_big: 'Check the quantity: 1,000 or more', qty_zero: 'Your list says 0: set a quantity',
    qty_is_key: 'Check the quantity: that number is also a part number', qty_converted: 'Check the quantity: we counted dozens as units',
    short_number: 'Pick the right item for this number', shared_number: 'More than one item carries this number',
    many_keys: 'This line names more than one part number', cart_said: 'The cart did not take this line'
  };
  var ORDER = ['cart_said', 'slash_pair', 'family', 'same_number', 'shared_number', 'desc_mismatch', 'unit_conflict', 'qty_zero', 'qty_converted',
    'qty_is_key', 'qty_extra', 'qty_big', 'short_number', 'many_keys'];
  var QTY_FLAGS = ['qty_zero', 'qty_extra', 'qty_big', 'qty_is_key', 'qty_converted'];
  var SIZE_CTX = /(?:^|[^a-z])(?:size|sz|miller|mac|fr|french|gauge|ga|no\.?|number|#)\s*$/i;
  function trailingQty(e, it) {               // "chest seal 5": once the buyer picks, 5 is the quantity unless it is in that item's title (a size); measured 25 of 27 right vs 7 for qty 1
    var d = String((e && e.desc) || ''), m = /(?:^|\s)(\d{1,3})\s*$/.exec(d), head, n, nums;
    if (!e || e.src !== 'default' || !it || !m) return 0;
    head = d.slice(0, m.index).trim();
    if (!head || SIZE_CTX.test(head)) return 0;
    n = parseInt(m[1], 10);
    nums = (it.title.match(/\d+(?:\.\d+)?/g) || []).map(function (x) { return x.replace(/\.0+$/, ''); });
    return n > 0 && nums.indexOf(String(n)) < 0 ? n : 0;
  }
  function hasAny(flags, list) { for (var i = 0; i < list.length; i++) if (flags.indexOf(list[i]) > -1) return true; return false; }
  function why(line) {
    if (line.result && line.result.state === 'phone') return 'Order by phone';
    for (var i = 0; i < ORDER.length; i++) if (line.flags.indexOf(ORDER[i]) > -1) return WHY[ORDER[i]] + (ORDER[i] === 'cart_said' && line.cartWhy ? ': ' + line.cartWhy : '');
    return 'Choose the item you want';
  }
  function contact(q) {
    var mail = T.email ? 'mailto:' + T.email + '?subject=' + encodeURIComponent('Quick Order') + (q ? '&body=' + encodeURIComponent('I am looking for: ' + q) : '') : '';
    return '<a href="tel:' + esc(T.tel) + '">' + esc(T.phone) + '</a>' + (mail ? ' &middot; <a href="' + esc(mail) + '">' + esc(T.email_label || 'Email us') + '</a>' : '');
  }
  function echo(line) {
    return line.src === 'paste' && line.raw ? '<div class="qo2-echo">From your list: ' + esc(line.raw.length > 90 ? line.raw.slice(0, 88) + '...' : line.raw) + '</div>' : '';
  }
  function qtyCtl(line) {
    return '<span class="qo2-qty"><button type="button" data-act="minus" aria-label="Less">&minus;</button>' +
      '<input type="text" inputmode="numeric" pattern="[0-9]*" value="' + line.qty + '" aria-label="Quantity" data-act="qty" maxlength="4">' +
      '<button type="button" data-act="plus" aria-label="More">+</button></span>';
  }
  function rowHTML(line, n) {
    var h = '';
    if (line.state === 'checking') {
      return '<li class="qo2-row qo2-row--checking" data-key="' + line.key + '"><div class="qo2-body">Checking ' + esc(line.raw) + '...</div></li>';
    }
    if (line.state === 'ready') {
      var it = line.pick;
      h = img(it) + '<div class="qo2-body"><a class="qo2-name" href="/products/' + encodeURIComponent(it.h) + '" target="_blank" rel="noopener">' + esc(it.title) + '</a>' +
        '<div class="qo2-meta">' + meta(it) + '</div>' + echo(line) +
        (line.qtyFrom ? '<div class="qo2-flag">We read the ' + line.qtyFrom + ' at the end of your line as the quantity</div>' :
          line.flags.indexOf('qty_default') > -1 && line.src === 'paste' ? '<div class="qo2-flag">Qty 1 (not in your list)</div>' : '') +
        (line.merged ? '<div class="qo2-flag">Combined from ' + line.merged + ' lines</div>' : '') +
        (GATE && it.gated ? '<div class="qo2-gate">' + esc(T.gated) + '</div>' : '') +
        '<div class="qo2-ctl">' + qtyCtl(line) + '<button type="button" class="qo2-link" data-act="del" aria-label="Delete ' + esc(it.title) + '">Delete</button>' +
        (line.chosen && line.options.length > 1 ? '<button type="button" class="qo2-link" data-act="change">Change</button>' : '') +
        '<span class="qo2-price">' + esc(money(it.price * line.qty)) + '</span></div></div>';
      return '<li class="qo2-row" data-key="' + line.key + '">' + h + '</li>';
    }
    if (line.state === 'look') {
      var cards = line.options.map(function (o, i) {
        return '<li class="qo2-card">' + img(o) + '<div class="qo2-card-title">' + esc(o.title) + '</div><div class="qo2-meta">' + meta(o) + '</div>' +
          '<div><b>' + esc(money(o.price)) + '</b></div><button type="button" class="button button--primary qo2-choose" data-act="pick" data-i="' + i + '" aria-label="Choose ' +
          esc(o.title) + ' for line ' + n + '">Choose</button></li>';
      }).join('');
      h = '<div class="qo2-body"><div class="qo2-echo">You wrote: ' + esc(line.raw) + (line.flags.indexOf('qty_default') > -1 ? '' : ' &middot; Qty ' + line.qty) + '</div>' +
        '<div class="qo2-why">' + esc(why(line)) + '</div>' +
        (line.fixed ? '<div class="qo2-flag">Showing results for &ldquo;' + esc(line.fixed) + '&rdquo;</div>' : '') +
        (line.busy ? '<div class="qo2-flag">Name search is busy. <button type="button" class="qo2-link" data-act="retry">Retry</button></div>' : '') +
        (hasAny(line.flags, QTY_FLAGS) ? '<div class="qo2-ctl">Quantity ' + qtyCtl(line) + '</div>' : '') +
        (cards ? '<ul class="qo2-cards" aria-label="Choices for line ' + n + '">' + cards + '</ul>' : '<div class="qo2-meta">' + contact(line.raw) + '</div>') +
        '<div class="qo2-ctl">' + (line.flags.indexOf('slash_pair') > -1 && line.options.length === 2 ? '<button type="button" class="qo2-link" data-act="both">Add both</button>' : '') +
        '<button type="button" class="qo2-link" data-act="instead">Search instead</button><button type="button" class="qo2-link" data-act="del">Remove</button></div></div>';
      return '<li class="qo2-row qo2-row--look" data-key="' + line.key + '">' + h + '</li>';
    }
    h = '<div class="qo2-body"><div><b>' + esc(T.not_found || "We couldn't find") + ' &ldquo;' + esc(line.raw) + '&rdquo;</b></div>' +
      (line.busy ? '<div class="qo2-flag">Name search is busy. <button type="button" class="qo2-link" data-act="retry">Retry</button></div>' : '') +
      '<div class="qo2-ctl"><button type="button" class="qo2-link" data-act="instead">Search instead</button><span class="qo2-meta">' + contact(line.raw) + '</span>' +
      '<button type="button" class="qo2-link" data-act="del">Remove</button></div></div>';
    return '<li class="qo2-row qo2-row--none" data-key="' + line.key + '">' + h + '</li>';
  }
  function byKey(k) { for (var i = 0; i < lines.length; i++) if (String(lines[i].key) === String(k)) return lines[i]; return null; }
  function counts() {
    var c = { ready: 0, units: 0, cents: 0, look: 0, none: 0, checking: 0 };
    lines.forEach(function (l) {
      if (l.state === 'ready') { c.ready++; c.units += l.qty; c.cents += l.pick.price * l.qty; }
      else if (l.state === 'look') c.look++;
      else if (l.state === 'none') c.none++;
      else c.checking++;
    });
    return c;
  }
  function render() {
    listEl.innerHTML = lines.map(function (l, i) { return rowHTML(l, i + 1); }).join('');
    listWrap.hidden = !lines.length;
    pasteWrap.hidden = !!lines.length && !pasteOpen;
    moreEl.hidden = !lines.length || pasteOpen;
    renderSummary();
    renderSkipped();
    save();
  }
  function renderSummary() {
    var c = counts();
    var label = c.ready ? (T.add_n || 'Add {n} to Cart').replace('{n}', c.ready) : (T.add_n || 'Add {n} to Cart').replace(/\s*\{n\}/, '');   // never "Add 0 to Cart"
    var btn = '<button type="button" class="button button--primary qo2-btn qo2-add" data-qo2-add' + (busyAdd ? ' aria-busy="true"' : '') + '>' +
      esc(busyAdd ? 'Adding...' : label) + '</button>';
    var note = c.checking ? 'Checking ' + c.checking + (c.checking === 1 ? ' line' : ' lines') + '...' :
      (c.look ? c.look + (c.look === 1 ? ' line needs' : ' lines need') + ' a look' : '') + (c.none ? (c.look ? ' &middot; ' : '') + c.none + ' not found' : '');
    var h = lines.length ? '<div class="qo2-subtotal">Subtotal at list price (' + c.ready + (c.ready === 1 ? ' item' : ' items') + '): <b>' + esc(money(c.cents)) + '</b></div>' +
      btn + '<p class="qo2-sumnote">' + note + '</p><p class="qo2-meta">Account pricing shows in your cart.</p>' : '';
    $$('[data-qo2-sum]').forEach(function (el) { el.innerHTML = h; el.hidden = !lines.length; });
    bottomEl.innerHTML = lines.length > 3 ? btn : '';
    bottomEl.hidden = lines.length <= 3;
    bannerEl.innerHTML = c.look + c.none ? '<span>' + (c.look + c.none) + ((c.look + c.none) === 1 ? ' line needs' : ' lines need') +
      ' your attention</span><button type="button" class="qo2-link" data-qo2-review>Review</button>' : '';
  }
  function renderSkipped() {
    if (!skipped.length) { skippedEl.innerHTML = ''; return; }
    skippedEl.innerHTML = '<details><summary>Skipped ' + skipped.length + (skipped.length === 1 ? ' line' : ' lines') + ' that did not look like items (show)</summary><ul>' +
      skipped.map(function (s, i) {
        return '<li>' + esc(s) + ' <button type="button" class="qo2-link" data-qo2-addskip="' + i + '">Add as item</button></li>';
      }).join('') + '</ul></details>';
  }

  /* ---------------------------------------------------------------- matching lines */
  function apply(line, r) {
    line.result = r;
    line.flags = (r.flags || []).slice();
    line.options = r.options || [];
    line.fixed = r.fixed || null;
    if (r.state === 'locked' && line.options[0]) {
      line.state = 'ready'; line.pick = line.options[0];
      if (line.qty < 1) line.qty = 1;
    } else if (r.state === 'notfound' || (!line.options.length && r.state !== 'phone')) {
      line.state = 'none';
    } else {
      line.state = 'look';
    }
    if (line.want) {
      for (var i = 0; i < line.options.length; i++) {
        if (String(line.options[i].id) === String(line.want)) { line.state = 'ready'; line.pick = line.options[i]; line.chosen = true; }
      }
      line.want = null;
    }
  }
  function matchLine(line) {
    line.state = 'checking'; line.busy = false;
    var p;
    try { p = E.match(line.entry, IX, function (q, fix) { return search(q, fix, line); }); } catch (e) { p = Promise.reject(e); }
    return Promise.resolve(p).then(function (r) { apply(line, r); }, function () { line.state = 'none'; line.busy = true; });
  }
  function mergeDuplicates() {
    var seen = {};
    lines = lines.filter(function (l) {
      if (l.state !== 'ready') return true;
      var k = String(l.pick.id), first = seen[k];
      if (!first) { seen[k] = l; return true; }
      first.qty += l.qty; first.merged = (first.merged || 1) + 1;
      return false;
    });
  }
  function readSafe(text, ix) {             // the engine should never throw; if it does, read line by line so one odd line cannot stop a paste
    try { return E.readBlock(text, ix); } catch (err) {
      var out = [];
      text.split(/\r\n|\r|\n/).forEach(function (l) {
        if (!l.trim()) return;
        try { out = out.concat(E.readBlock(l, ix)); } catch (e2) { out.push({ raw: l, noise: true }); }   // shown under Skipped, with Add as item
      });
      return out;
    }
  }
  var overflow = [];                          // lines past the MAX cap: put back in the paste box, never dropped
  function addEntries(entries, src) {
    var made = [];
    overflow = [];
    entries.forEach(function (e) {
      if (e.noise) {
        if (!e.continued) { var s = e.clause || e.raw; if (s && skipped.indexOf(s) < 0) skipped.push(s); }
        return;
      }
      if (lines.length + made.length >= MAX) { if (e.raw && overflow.indexOf(e.raw) < 0) overflow.push(e.raw); return; }
      made.push({ key: nextKey++, raw: e.raw || e.text || '', entry: e, src: src, state: 'checking', options: [], pick: null,
        qty: e.qty == null ? 1 : e.qty, flags: [], fixed: null });
    });
    lines = lines.concat(made);
    render();
    return made;
  }
  function runLines(made) {
    if (!made.length) return Promise.resolve();
    var done = 0;
    return Promise.all(made.map(function (l) {
      return matchLine(l).then(function () {
        done++;
        if (done % 5 === 0 || done === made.length) { mergeDuplicates(); render(); say('Matched ' + done + ' of ' + made.length); }
      });
    })).then(function () { mergeDuplicates(); render(); });
  }
  function findPasted() {
    var text = pasteBox.value;
    if (!text.trim()) { pasteBox.focus(); return; }
    msg('');
    ensureIndex().then(function (ix) {
      if (!ix) { msg('<p>Quick Order could not load the part number list. Please try again or call us: ' + contact('') + '</p>', 'bad'); return; }
      var entries = readSafe(text, ix);
      var pasted = text.split(/\r\n|\r|\n/).filter(function (l) { return l.trim(); }).length;
      var before = skipped.length;
      var made = addEntries(entries, 'paste'), over = overflow.slice();
      pasteBox.value = over.join('\n'); pasteOpen = over.length > 0;
      clarity('event', 'pbm_qo2_paste');
      render();
      if (made[0]) {
        var el = listEl.querySelector('[data-key="' + made[0].key + '"]');
        if (el && el.scrollIntoView) el.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      return runLines(made).then(function () {
        var c = { ready: 0, units: 0, look: 0, none: 0 };
        made.forEach(function (l) {
          if (l.state === 'ready') { c.ready++; c.units += l.qty; } else if (l.state === 'look') c.look++; else c.none++;
        });
        var sk = skipped.length - before;
        lastReceipt = 'You pasted ' + pasted + (pasted === 1 ? ' line' : ' lines') + ': ' + c.ready + (c.ready === 1 ? ' item' : ' items') + ' ready (' + c.units + ' units)' +
          (c.look ? ' · ' + c.look + ' need a look' : '') + (c.none ? ' · ' + c.none + ' not found' : '') + (sk ? ' · ' + sk + ' skipped' : '') +
          (over.length ? ' · ' + over.length + ' not read yet' : '');
        receiptEl.textContent = lastReceipt;
        say(lastReceipt);
        if (c.look) clarity('event', 'pbm_qo2_look');
        if (c.none) clarity('event', 'pbm_qo2_not_found');
        if (over.length) msg('<p>Quick Order reads ' + MAX + ' items at a time. The other ' + over.length + (over.length === 1 ? ' line is' : ' lines are') +
          ' still in the paste box: add these to your cart first, then press &ldquo;' + esc(findBtn.textContent.trim()) + '&rdquo; again.</p>', 'bad');
        save();
      });
    }).catch(function () { render(); msg('<p>Something went wrong reading that list. Please try again or call us: ' + contact('') + '</p>', 'bad'); });
  }

  /* ---------------------------------------------------------------- search box and dropdown */
  var dd = { list: [], active: -1, seq: 0, timer: null, entry: null, result: null };
  function ddOpen(on) {
    ddBox.hidden = !on;
    sInput.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (!on) sInput.removeAttribute('aria-activedescendant');
  }
  function ddDraw(list, note) {
    dd.list = list || [];
    if (note) { ddBox.innerHTML = '<p class="qo2-ddnote">' + esc(note) + '</p>'; ddOpen(true); return; }
    if (!dd.list.length) { ddBox.innerHTML = '<p class="qo2-ddnote">No matches yet. Keep typing, or paste it as a line.</p>'; ddOpen(true); return; }
    ddBox.innerHTML = dd.list.map(function (o, i) {
      return '<div class="qo2-opt' + (i === dd.active ? ' is-active' : '') + '" role="option" id="qo2-opt-' + i + '" aria-selected="' + (i === dd.active) + '" data-i="' + i + '">' +
        img(o, 'qo2-img--sm') + '<div class="qo2-body"><div>' + (o.why === 'exact' ? '<span class="qo2-tag">Exact match</span> ' : '') + esc(o.title) + '</div>' +
        '<div class="qo2-meta">' + meta(o) + ' &middot; ' + esc(money(o.price)) + '</div></div></div>';
    }).join('');
    ddOpen(true);
    if (dd.active > -1) sInput.setAttribute('aria-activedescendant', 'qo2-opt-' + dd.active);
  }
  function tagged(o, why) { var c = {}; for (var k in o) c[k] = o[k]; c.why = why; return c; }
  function suggest() {
    var q = sInput.value.trim(), seq = ++dd.seq;
    if (q.length < 2) { ddOpen(false); return; }
    ddDraw(null, 'Searching...');
    ensureIndex().then(function (ix) {
      if (!ix) { if (seq === dd.seq) ddDraw(null, 'The part number list could not load. Try again in a moment.'); return; }
      var e = readSafe(q, ix).filter(function (x) { return !x.noise; })[0] || null;
      var mine = Promise.resolve({ options: [], state: 'notfound', flags: [] });
      if (e) { try { mine = Promise.resolve(E.match(e, ix, search)); } catch (err) { /* keep the empty answer; Searchanise still fills the list */ } }
      return Promise.all([mine, search(q, false)]).then(function (res) {
        if (seq !== dd.seq) return;
        var r = res[0], seen = {}, list = [];
        (r.options || []).forEach(function (o) { if (!seen[o.id]) { seen[o.id] = 1; list.push(tagged(o, r.state === 'locked' ? 'exact' : '')); } });
        (res[1].items || []).forEach(function (x) {
          var it = ix.byh && ix.byh[x.h];
          if (it && !it.kids && !seen[it.id]) { seen[it.id] = 1; list.push(it); }
        });
        dd.active = -1; dd.entry = e; dd.result = r;
        ddDraw(list.slice(0, 8));
      });
    }).catch(function () { if (seq === dd.seq) ddDraw(null, 'Search is busy. Try again in a moment.'); });
  }
  function addPicked(it, e, how) {
    var q = e && e.src && e.src !== 'default' && e.qty > 0 ? e.qty : 1, tq = trailingQty(e, it);
    var line = { key: nextKey++, raw: sInput.value.trim(), entry: e, src: 'search', state: 'ready', options: [it], pick: it, qty: tq || q, qtyFrom: tq, flags: [], fixed: null, chosen: how !== 'exact' };
    lines.push(line);
    mergeDuplicates();
    sInput.value = ''; ddOpen(false); dd.list = [];
    render();
    toast('Added ' + esc(it.title), function () { lines = lines.filter(function (l) { return l !== line; }); render(); });
    say('Added to your list');
    sInput.focus();
  }
  sInput.addEventListener('input', function () { clearTimeout(dd.timer); dd.timer = setTimeout(suggest, DD_DELAY); });
  sInput.addEventListener('keydown', function (e) {
    var n = dd.list.length;
    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && n && !ddBox.hidden) {
      e.preventDefault();
      dd.active = e.key === 'ArrowDown' ? (dd.active + 1) % n : (dd.active <= 0 ? n - 1 : dd.active - 1);
      ddDraw(dd.list);
      var a = d.getElementById('qo2-opt-' + dd.active);
      if (a && a.scrollIntoView) a.scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Escape') {
      ddOpen(false);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (n && dd.active > -1) addPicked(dd.list[dd.active], dd.entry, 'dropdown');
      else if (dd.result && dd.result.state === 'locked' && dd.list[0] && sInput.value.trim()) addPicked(dd.list[0], dd.entry, 'exact');
      else { clearTimeout(dd.timer); suggest(); }
    }
  });
  ddBox.addEventListener('mousedown', function (e) { e.preventDefault(); });
  ddBox.addEventListener('click', function (e) {
    var o = e.target.closest('[data-i]');
    if (o) addPicked(dd.list[parseInt(o.getAttribute('data-i'), 10)], dd.entry, 'dropdown');
  });
  $('[data-qo2-sgo]').addEventListener('click', function () { clearTimeout(dd.timer); suggest(); sInput.focus(); });
  d.addEventListener('pointerdown', function (e) {
    if (!ddBox.hidden && !(e.target.closest && e.target.closest('[data-qo2-search]'))) ddOpen(false);
  }, true);

  /* ---------------------------------------------------------------- row actions */
  listEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    var li = b.closest('[data-key]'), line = li && byKey(li.getAttribute('data-key'));
    if (!line) return;
    var act = b.getAttribute('data-act'), i;
    if (act === 'minus' || act === 'plus') { line.qty = Math.max(1, Math.min(9999, line.qty + (act === 'plus' ? 1 : -1))); line.qtyFrom = 0; line.qtyTouched = true; render(); return; }
    if (act === 'del') {
      var at = lines.indexOf(line);
      lines.splice(at, 1);
      render();
      toast('Removed ' + esc(line.pick ? line.pick.title : line.raw), function () { lines.splice(Math.min(at, lines.length), 0, line); render(); });
      say('Removed. Undo is available');
      return;
    }
    if (act === 'pick') {
      var it = line.options[parseInt(b.getAttribute('data-i'), 10)];
      if (!it) return;
      line.state = 'ready'; line.pick = it; line.chosen = true;
      line.flags = line.flags.filter(function (f) { return QTY_FLAGS.indexOf(f) < 0; });
      if (line.qty < 1) line.qty = 1;
      var tq = line.qtyTouched ? 0 : trailingQty(line.entry, it);
      if (tq) { line.qty = tq; line.qtyFrom = tq; } else if (line.qtyFrom) { line.qty = 1; line.qtyFrom = 0; }   // a re-pick whose title has that number: it was a size
      mergeDuplicates(); render(); clarity('event', 'pbm_qo2_choose');
      for (i = 0; i < lines.length; i++) {
        if (lines[i].state === 'look' || lines[i].state === 'none') {
          var f = listEl.querySelector('[data-key="' + lines[i].key + '"] button');
          if (f) f.focus();
          break;
        }
      }
      say('Chosen');
      return;
    }
    if (act === 'change') { if (line.options.length > 1) { line.state = 'look'; line.chosen = false; render(); } return; }
    if (act === 'both') {
      var a = line.options[0], c = line.options[1];
      line.state = 'ready'; line.pick = a; line.chosen = true;
      lines.splice(lines.indexOf(line) + 1, 0, { key: nextKey++, raw: line.raw, entry: line.entry, src: line.src, state: 'ready', options: [c], pick: c, qty: line.qty, flags: [], fixed: null, chosen: true });
      mergeDuplicates(); render();
      return;
    }
    if (act === 'instead') {
      sInput.value = (line.entry && (line.entry.text || line.entry.desc)) || line.raw;
      lines.splice(lines.indexOf(line), 1);
      render();
      sInput.focus(); suggest();
      return;
    }
    if (act === 'retry') { render(); matchLine(line).then(function () { mergeDuplicates(); render(); }); }
  });
  listEl.addEventListener('change', function (e) {
    var b = e.target.closest('[data-act="qty"]');
    if (!b) return;
    var line = byKey(b.closest('[data-key]').getAttribute('data-key'));
    var n = parseInt(String(b.value).replace(/\D/g, ''), 10);
    if (!line) return;
    line.qty = isNaN(n) || n < 1 ? 1 : Math.min(n, 9999); line.qtyFrom = 0; line.qtyTouched = true;
    if (line.state === 'look' && line.options.length === 1 && hasAny(line.flags, QTY_FLAGS)) {    // the buyer confirmed the quantity
      line.flags = line.flags.filter(function (f) { return QTY_FLAGS.indexOf(f) < 0; });
      if (!line.flags.length || line.flags.join() === 'qty_default') { line.state = 'ready'; line.pick = line.options[0]; line.chosen = true; }
    }
    render();
  });
  listEl.addEventListener('keydown', function (e) {
    var cards = e.target.closest('.qo2-cards');
    if (!cards || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var bs = Array.prototype.slice.call(cards.querySelectorAll('button')), i = bs.indexOf(e.target);
    if (i < 0) return;
    e.preventDefault();
    var nx = bs[Math.max(0, Math.min(bs.length - 1, i + (e.key === 'ArrowRight' ? 1 : -1)))];
    nx.focus();
    if (nx.scrollIntoView) nx.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
  skippedEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qo2-addskip]');
    if (!b) return;
    var i = parseInt(b.getAttribute('data-qo2-addskip'), 10), s = skipped[i];
    if (s == null) return;
    skipped.splice(i, 1);
    var entry = { raw: s, parts: [], desc: s, text: s, qty: 1, src: 'default', unit: null, extra: [], whole: null, short: false };
    var made = addEntries([entry], 'paste');
    if (!made.length) { skipped.splice(i, 0, s); render(); msg('<p>Your list is full (' + MAX + ' lines). Add these to your cart first.</p>', 'bad'); return; }
    runLines(made);
  });
  bannerEl.addEventListener('click', function (e) {
    if (!e.target.closest('[data-qo2-review]')) return;
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].state === 'look' || lines[i].state === 'none') {
        var el = listEl.querySelector('[data-key="' + lines[i].key + '"]');
        if (el) {
          el.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var f = el.querySelector('button');
          if (f) f.focus({ preventScroll: true });
        }
        break;
      }
    }
  });
  findBtn.addEventListener('click', findPasted);
  $('[data-qo2-showpaste]').addEventListener('click', function () { pasteOpen = true; render(); pasteBox.focus(); });
  $('[data-qo2-clear]').addEventListener('click', function () {
    var keep = lines, keepS = skipped, keepR = lastReceipt;
    lines = []; skipped = []; lastReceipt = ''; receiptEl.textContent = ''; msg('');
    render();
    toast('List cleared', function () { lines = keep; skipped = keepS; lastReceipt = keepR; receiptEl.textContent = keepR; render(); });
  });

  /* ---------------------------------------------------------------- add to cart */
  function msg(html, kind) { msgEl.innerHTML = html || ''; msgEl.className = 'qo2-msg' + (html && kind ? ' qo2-msg--' + kind : ''); }
  function post(items) {
    return fetch(ADD_URL, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (r.ok) return j;
        var e = new Error(j.description || j.message || ('HTTP ' + r.status));
        e.status = r.status;
        throw e;
      });
    });
  }
  function lineOf(l) { return { id: l.pick.id, quantity: l.qty, properties: { _src: 'quick_order' } }; }
  function addAll() {
    if (busyAdd) return;
    var go = lines.filter(function (l) { return l.state === 'ready'; });
    if (!go.length) {
      msg('<p>Nothing is ready yet. Choose items in the lines that need a look.</p>', 'bad');
      var rv = bannerEl.querySelector('[data-qo2-review]');
      if (rv) rv.click();
      return;
    }
    busyAdd = true; renderSummary(); msg('');
    clarity('event', 'pbm_qo2_add_all');
    post(go.map(lineOf)).then(function () { finish(go, []); }, function (err) {
      if (err.status !== 422) { finish([], []); return; }
      var ok = [], bad = [];
      go.reduce(function (p, l) {
        return p.then(function () { return post([lineOf(l)]).then(function () { ok.push(l); }, function (e2) { bad.push({ l: l, why: e2.message }); }); });
      }, Promise.resolve()).then(function () { finish(ok, bad); });
    });
  }
  function finish(ok, bad) {
    busyAdd = false;
    lines = lines.filter(function (l) { return ok.indexOf(l) < 0; });
    bad.forEach(function (b) { b.l.state = 'look'; b.l.flags = ['cart_said']; b.l.cartWhy = b.why; b.l.options = [b.l.pick]; });
    if (ok.length && !lines.length) { store(LIST_KEY, null); w.location.href = CART_URL; return; }
    if (ok.length) { lastReceipt = ''; receiptEl.textContent = ''; }   // the paste receipt no longer describes what is left
    render();
    if (!ok.length) { msg('<p>Nothing was added to your cart. Please try again or call us: ' + contact('') + '</p>', 'bad'); return; }
    msg('<p>' + ok.length + (ok.length === 1 ? ' item' : ' items') + ' added to your cart. The lines below were not added yet.</p><p><a class="button button--primary qo2-btn" href="' +
      esc(CART_URL) + '">' + esc(T.go_cart || 'Go to Cart') + '</a></p>', 'ok');
    getJSON(CART_URL + '.js').then(function (c) {
      Array.prototype.forEach.call(d.querySelectorAll('.header-cart__count'), function (n) { n.textContent = c.item_count; });
    }).catch(function () {});
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-qo2-add]')) addAll(); });

  /* ---------------------------------------------------------------- keep the list for this tab */
  var saveTimer = null;
  function save() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      if (!lines.length && !skipped.length) { store(LIST_KEY, null); return; }
      store(LIST_KEY, JSON.stringify({ t: Date.now(), skipped: skipped, receipt: lastReceipt, lines: lines.map(function (l) {
        return { raw: l.raw, src: l.src, qty: l.qty, qtyFrom: l.qtyFrom || 0, qtyTouched: !!l.qtyTouched, pick: l.state === 'ready' ? l.pick.id : null, chosen: !!l.chosen, entry: l.entry };
      }) }));
    }, 250);
  }
  function restore() {
    var data = null;
    try { data = JSON.parse(load(LIST_KEY) || 'null'); } catch (e) {}
    if (!data || !data.lines || !data.lines.length) return;
    ensureIndex().then(function (ix) {
      if (!ix) return;
      skipped = data.skipped || [];
      var again = [];
      data.lines.forEach(function (s) {
        var it = s.pick && ix.byId[s.pick];
        var l = { key: nextKey++, raw: s.raw, entry: s.entry, src: s.src, qty: s.qty || 1, qtyFrom: s.qtyFrom || 0, qtyTouched: !!s.qtyTouched, options: it ? [it] : [], pick: it || null, flags: [], fixed: null,
          chosen: s.chosen, state: it ? 'ready' : 'checking' };
        if (it || s.entry) { lines.push(l); if (!it) again.push(l); }
      });
      if (data.receipt) receiptEl.textContent = lastReceipt = data.receipt;
      render();
      msg('<p>We kept your list from earlier in this tab. <button type="button" class="qo2-link" data-qo2-clear2>Clear list</button></p>', 'ok');
      runLines(again);
    });
  }
  msgEl.addEventListener('click', function (e) { if (e.target.closest('[data-qo2-clear2]')) { msg(''); $('[data-qo2-clear]').click(); } });

  /* ---------------------------------------------------------------- start */
  render();
  restore();
  var warm = function () { ensureIndex(); };
  if (w.requestIdleCallback) w.requestIdleCallback(warm, { timeout: 1500 }); else setTimeout(warm, 300);
})();
